import React, { useState } from 'react';

const ImageGallery = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  
  const galleryImages = [
    { id: 1, src: '/images/kiddies-1.jpg', category: 'kiddies', title: 'Piano Fun' },
    { id: 2, src: '/images/kiddies-2.jpg', category: 'kiddies', title: 'Milk Bath' },
    { id: 3, src: '/images/kiddies-3.jpg', category: 'kiddies', title: 'Cake Smash' },
    { id: 4, src: '/images/adults-1.jpg', category: 'adults', title: 'Birthday' },
    { id: 5, src: '/images/family-1.jpg', category: 'family', title: 'Family Love' },
    { id: 6, src: '/images/kiddies-4.jpg', category: 'kiddies', title: 'Car Theme' }
  ];

  const filteredImages = activeCategory === 'all' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === activeCategory);

  return (
    <section id="gallery" className="gallery">
      <div className="container">
        <h2 className="section-title">Our Portfolio</h2>
        
        <div className="gallery-filters">
          <button className={`filter-btn ${activeCategory === 'all' ? 'active' : ''}`} onClick={() => setActiveCategory('all')}>
            All Photos
          </button>
          <button className={`filter-btn ${activeCategory === 'kiddies' ? 'active' : ''}`} onClick={() => setActiveCategory('kiddies')}>
            Kiddies
          </button>
          <button className={`filter-btn ${activeCategory === 'adults' ? 'active' : ''}`} onClick={() => setActiveCategory('adults')}>
            Adults
          </button>
          <button className={`filter-btn ${activeCategory === 'family' ? 'active' : ''}`} onClick={() => setActiveCategory('family')}>
            Family
          </button>
        </div>

        <div className="gallery-grid">
          {filteredImages.map(image => (
            <div key={image.id} className="gallery-item">
              <img 
                src={image.src} 
                alt={image.title}
                className="gallery-image"
                onError={(e) => {
                  e.target.src = `https://placehold.co/400x300/fed7d7/7f1d1d?text=${image.title}`;
                }}
              />
              <div className="image-overlay">
                <div className="image-title">{image.title}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ImageGallery;